import State from '@/Store';
import { AxiosInstance } from 'axios';
import AuthRepositoryInterface, { UserLoginPayload } from '@/services/Auth/Interfaces';
import { DepartmentInterface } from '../Departments/Interfaces';

export default class AuthRepository implements AuthRepositoryInterface {
  constructor(
    private axios: AxiosInstance,
  ) {
  }

  public async login(username: string, password: string): Promise<UserLoginPayload> {
    const res = await this.axios.post('/auth/token', {
      user: username,
      password,
      },
    );

    return res.data;
  }

  public async logout(): Promise<void> {
    await this.axios.get('/auth/logout', {
      headers: {
        Authorization: State.getters.jwt,
      },
    });
    State.commit('USER_LOGOUT');
  }

  public async getUserIdsByDepartments(departmentIds: string[]): Promise<string[]> {
    const url = '/auth/users-departments?';
    const queryParams = departmentIds.map((id) => `ids=${id}`).join('&');
    const res = await this.axios.get(url + queryParams);

    return res.data;
  }
}
